var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroProfPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 3.125C7.58386 3.125 5.6251 5.08375 5.6251 7.5C5.6251 9.91625 7.58386 11.875 10.0001 11.875C12.4164 11.875 14.3751 9.91625 14.3751 7.5C14.3751 5.08375 12.4164 3.125 10.0001 3.125ZM4.3751 7.5C4.3751 4.3934 6.8935 1.875 10.0001 1.875C13.1067 1.875 15.6251 4.3934 15.6251 7.5C15.6251 10.6066 13.1067 13.125 10.0001 13.125C6.8935 13.125 4.3751 10.6066 4.3751 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 13.1243C8.57374 13.1243 7.17251 13.4998 5.93728 14.213C4.70205 14.9263 3.67634 15.9521 2.96327 17.1875C2.79071 17.4864 2.40848 17.5889 2.10953 17.4163C1.81058 17.2437 1.70812 16.8615 1.88068 16.5626C2.70345 15.1372 3.88696 13.9535 5.31223 13.1305C6.7375 12.3076 8.3543 11.8743 10.0001 11.8743C11.6459 11.8743 13.2627 12.3076 14.688 13.1305C16.1132 13.9535 17.2968 15.1372 18.1195 16.5626C18.2921 16.8615 18.1896 17.2437 17.8907 17.4163C17.5917 17.5889 17.2095 17.4864 17.0369 17.1875C16.3239 15.9521 15.2982 14.9263 14.0629 14.213C12.8277 13.4998 11.4265 13.1243 10.0001 13.1243Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroProfPlaceholder);
export default __webpack_public_path__ + "static/media/intro-prof-placeholder.dcbd7c5b26160498abd6d1b1c62545c0.svg";
export { ForwardRef as ReactComponent };